import { NotImplementedError } from "../../../../errors";
import { parseDateFilter, parseGeofenceMultipoints } from "../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../handlers";
import { GEO_MAP_GEOFENCE_QUERY } from "./query";
/**
 * Typed handler for the Geo Map geofence overlay (Phase 2). Fetches the single
 * aggregated geofence FeatureCollection and parses it in the SDK so the frontend
 * never handles the raw JSON string.
 */
export default class LookerOverviewGeofences extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-geofences");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const queryBody = {
            ...GEO_MAP_GEOFENCE_QUERY,
            filters: {
                "explore_overview.flt_date_range": parseDateFilter(dateFilter)
            }
        };
        const lookbackFilter = filters.where?.find((filter) => filter.field === "lookbackDays");
        if (lookbackFilter?.value !== undefined && lookbackFilter.value !== null) {
            queryBody.filters["explore_overview.pmt_lookback_window"] = String(lookbackFilter.value);
        }
        // Media type selection maps to product_group (one value or comma-joined).
        // Requires the LookML geofence field to respect product_group; an
        // empty/absent selection returns the all-products aggregate.
        const mediaTypeFilter = filters.where?.find((filter) => filter.field === "mediaType");
        const mediaType = mediaTypeFilter?.value;
        if (mediaType && mediaType.length) {
            queryBody.filters["explore_overview.product_group"] = Array.isArray(mediaType)
                ? mediaType.join(",")
                : mediaType;
        }
        // Fail closed: geofences are partner-scoped by advertiser + campaign only.
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        const advertiserIds = advertiserFilter?.value;
        if (!advertiserIds?.length) {
            throw new Error("Advertiser ids filter is required");
        }
        queryBody.filters["advertisers.advertiser_id"] = advertiserIds.join(",");
        const campaignFilter = filters.where?.find((filter) => filter.field === "campaignIds");
        const campaignIds = campaignFilter?.value;
        if (!campaignIds?.length) {
            throw new Error("Campaign ids filter is required");
        }
        queryBody.filters["campaigns.campaign_id"] = campaignIds.join(",");
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: [this.formatResponse(data)],
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard geofences");
        }));
    }
    formatResponse(data) {
        return parseGeofenceMultipoints(data[0]?.["explore_overview.geofence_multipoints"]);
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Geofences.js.map